<template>
  <v-container class="alumni none-fluid link">
    <v-tabs
      right
      background-color="transparent"
      color="rgb(153, 27, 30)"
      value="ALUMNI"
      v-model="active"
      class="people-tabs"
    >
      <v-tab @click="$router.push({ name: 'People' })">CURRENT</v-tab>
      <v-tab>ALUMNI</v-tab>
    </v-tabs>
    <br />
    <v-expansion-panels multiple v-model="panels" class="mx-auto alumi-content">
      <v-expansion-panel
        v-for="section in sections"
        :key="section.title"
        expand
      >
        <v-expansion-panel-header class="expansion-header">{{
          section.title
        }}</v-expansion-panel-header>
        <v-expansion-panel-content class="expansion-content">
          <div
            v-for="(content, i) in section.content.slice().reverse()"
            :key="i"
            class="expansion-subsection"
          >
            <div
              v-html="$sanitize(content)"
            ></div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { getAllAlumni } from "../../service/about/alumni";

export default {
  data() {
    return { panels: [], active: 1, sections: [] };
  },
  mounted() {
    getAllAlumni()
      .then((sections) => {
        this.sections = sections;
        for (let i = 0; i < sections.length; ++i) {
          this.panels.push(i);
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
};
</script>